(function () {

    let buildElements_default = isMobile() ? 50 : 250
    let buildElements = parseInt(getCookie(LIST.category + '_listLength') !== undefined ? getCookie(LIST.category + '_listLength') : buildElements_default) // минимальное количество элементов для прорисовки
    let groupIf = 50 // минимальное значение карточек для группировки
    let sortField = LIST.category + '_order' in window.localStorage ? window.localStorage.getItem(LIST.category + '_order') : 'title'      // сортировка
    let scrolled = 0
    let showIcons = getCookie(LIST.category + '_hideIcons') === undefined // флаг на отрисовку иконок
    let showSearch = getCookie(LIST.category + '_hideSearch') === undefined // флаг на скрытие поиска
    let listCardBody = document.getElementById('listCardBody')
    let cardList = document.getElementById('list')
    let listLoader = document.getElementById('listLoader')
    let listEmptyMessage = document.getElementById('listEmptyMessage')
    let listEmptyResult = document.getElementById('listEmptyResult')
    let listOrder = document.getElementById('listOrder')
    let listSettings = document.getElementById('listSettings')
    let searchForm = document.querySelector('form.search_columns')
    let toggleSearchFormBtn = HTML.createElement('button', ['btn', 'btn-sm', 'btn-gray'])
    let settingsBtn = HTML.createElement('button', ['btn', 'btn-sm', 'btn-gray'])

    let observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    scrolled = window.scrollY
                    buildList()
                    window.scrollTo({top: scrolled, left: 0, behavior: "instant"})
                }
            }
        )
    }, {
        root: null,
        threshold: 0,
    })

    document.getElementById('listLoader_more').addEventListener('click', () => {
        buildList()
    })

    sortField = sortField.replace('_name', '')

    function sortList() {
        const sorting = LIST.category + '_' + sortField;
        switch (sorting) {
            case 'spells_title':
                LIST.cards.sort((a, b) => (a.title_sort > b.title_sort) ? 1 : ((b.title_sort > a.title_sort) ? -1 : 0))
                break;
            case 'spells_title_en':
                LIST.cards.sort((a, b) => (a[sortField] > b[sortField]) ? 1 : ((b[sortField] > a[sortField]) ? -1 : 0))
                break;

            case 'spells_level':
                LIST.cards.sort(function (a, b) {
                    let aa = a[sortField] === 'Заговор' ? 0 : a[sortField]
                    let bb = b[sortField] === 'Заговор' ? 0 : b[sortField]
                    return (aa > bb) ? 1 : ((bb > aa) ? -1 : (a.title_sort > b.title_sort ? 1 : (b.title_sort > a.title_sort ? -1 : 0)))
                })
                break;

            default:
                LIST.cards.sort((a, b) => (a[sortField] > b[sortField]) ? 1 : ((b[sortField] > a[sortField]) ? -1 : (a.title_sort > b.title_sort ? 1 : (b.title_sort > a.title_sort ? -1 : 0))))
                break;
        }
    }

    function resetList() {
        console.log('resetList');
        for (const [id, data] of Object.entries(LIST.cards)) {
            delete LIST.cards[id].builded
        }
        cardList.innerHTML = ''
        listLoader.classList.remove('hidden')
    }

    function mapVisible(data) {
        return Object.entries(data.filter).every(([key, value]) => {
            // если value == true то текущий фильтр скрывает карточку
            // карточка скрыта, если хотя бы 1 фильтр == true
            let result = value

            // пары ИЛИ
            if (key === 'spells_class' || key === 'spells_subclass') {
                if ('spells_class' in data.filter && 'spells_subclass' in data.filter) {
                    result = data.filter['spells_subclass'] === true && data.filter['spells_class'] === true
                }
            }

            return result === false
        })
    }

    function buildList() {
        console.log('buildList');

        listLoader.classList.remove('hidden')
        listEmptyMessage.classList.remove('active')
        listEmptyResult.classList.remove('active')

        observer.unobserve(listLoader)

        let filtered = 0;
        Object.values(LIST.cards).map((a) => filtered += mapVisible(a) ? 1 : 0)

        let total = Object.keys(LIST.cards).length

        cardList.classList.toggle('short', filtered < groupIf)

        // если по настройкам пустой список
        if (total === filtered && !buildElements) {

            listLoader.classList.add('hidden')
            listEmptyMessage.classList.add('active')
            listCardBody.classList.remove('filtering')

            return
        }

        let currentSort = ''
        let counter = 0
        let makeGroups = true
        let currentBlock

        for (const [id, data] of Object.entries(LIST.cards)) {

            // скрываем блок лоадера
            if (parseInt(id) === Object.keys(LIST.cards).length - 1) {
                listLoader.classList.add('hidden')
            }

            // пропускаем скрытые элементы
            if (typeof data.builded !== 'undefined' || !mapVisible(data)) {
                continue
            }

            counter++

            let blockTag = sortField !== 'title' && sortField !== 'title_en' ? data[sortField] : data.title_sort.slice(0, 1)

            // формируем новый блок группировки
            if (currentSort !== blockTag && makeGroups) {

                // прерываем отрисовку при достижении порога отрисовки
                if (counter > (buildElements === 0 ? buildElements_default : buildElements)) {
                    break
                }

                makeGroups = filtered >= groupIf

                currentSort = blockTag

                let block = newElement('li.cards_list__block-wrapper')
                cardList.appendChild(block)

                let blockLabel = newElement('div.cards_list__block-label')
                blockLabel.innerText = blockTag
                if (sortField !== 'title' && sortField !== 'title_en' && blockTag.length > 1) {
                    blockLabel.classList.add('vertical')
                }
                block.appendChild(blockLabel)

                currentBlock = newElement('ul.cards_list__block');
                block.appendChild(currentBlock)

            }

            let item = newElement('li.cards_list__item')

            let a = newElement('a.cards_list__item-wrapper')
            a.setAttribute('href', data.link)
            item.appendChild(a)

            // начало в квадратных скобках [1/2]
            if ('item_prefix' in data) {
                let mark = newElement('span.cards_list__item-prefix')
                mark.innerHTML = '[<span>' + data.item_prefix + '</span>]'
                mark.setAttribute('title', data.item_prefix_title)
                a.appendChild(mark)
            }

            // иконка
            if ('item_icon' in data && showIcons) {
                let icon = newElement('span.cards_list__item-icon')
                icon.setAttribute('title', data.item_icon_title)
                icon.appendChild(drawIcon(data.item_icon, 16))
                a.appendChild(icon)
            }

            // текст
            let name = newElement('span.cards_list__item-name')
            name.innerText = data.title
            a.appendChild(name)

            // теги
            for (const [tag_key, tag_params] of Object.entries(data.item_tags)) {
                let tag = newElement('span.cards_list__item-tag.' + tag_key)
                tag.setAttribute('title', tag_params.tag_title)
                tag.innerText = tag_params.tag_value
                a.appendChild(tag)
            }

            // суффикс
            if ('item_suffix' in data) {
                let suffix = newElement('span.cards_list__item-suffix')
                suffix.innerText = data.item_suffix
                a.appendChild(suffix)
            }

            LIST.cards[id].builded = true;

            currentBlock.appendChild(item)

        }

        if (!counter) {
            listEmptyResult.classList.add('active')
        }

        // перзапускаем обзервер
        observer.observe(listLoader)

        listCardBody.classList.remove('filtering')

    }

    // скрытое поле формы с сортировкой
    let inputSort = newElement('input')
    inputSort.setAttribute('type', 'hidden')
    inputSort.setAttribute('name', 'sortBy')
    inputSort.setAttribute('value', JSON.stringify([sortField]))

    // создаем меню сортировки
    for (const [key, title] of Object.entries(LIST.order)) {

        let menuItem = newElement('li.cards-list__sort-menu__item')
        listOrder.appendChild(menuItem)

        let btn = newElement('button.btn.btn-sm.btn-primary')
        btn.innerText = title
        btn.classList.toggle('active', key === sortField)
        menuItem.appendChild(btn)

        btn.addEventListener('click', () => {
            if (sortField !== key) {

                listOrder.querySelectorAll('.btn.active').forEach((btnActive) => {
                    btnActive.classList.remove('active')
                })

                sortField = key
                window.localStorage.setItem(LIST.category + '_order', sortField)
                btn.classList.add('active')

                resetList()

                sortList()

                buildList()

                inputSort.setAttribute('value', JSON.stringify([sortField]))

            }
        })
    }

    let menuFiller = newElement('li.cards-list__sort-menu__filler')
    listOrder.appendChild(menuFiller)

    // ветвление по сортировкам
    sortList()

    buildList()

    document.addEventListener('filter-start', () => {
        listCardBody.classList.add('filtering')
    })

    document.addEventListener('filter', () => {
        resetList()
        buildList()
    })

    // клик по лоадеру перезапускает подгрузку, если что-то не так
    listLoader.addEventListener('click', () => {
        scrolled = window.scrollY
        buildList()
        window.scrollTo({top: scrolled, left: 0, behavior: "instant"})
    })

    // добавляем кнопку настройки и кнопку показа меню
    if ('undefined' !== typeof sortField) {

        let menuItem = newElement('li.cards-list__sort-menu__item')
        listOrder.appendChild(menuItem)

        toggleSearchFormBtn.classList.toggle('btn-hidden', showSearch)
        toggleSearchFormBtn.appendChild(drawIcon('search', 16))
        menuItem.appendChild(toggleSearchFormBtn)
        toggleSearchFormBtn.addEventListener('click', () => {
            searchForm.classList.toggle('hidden')
        })

        menuItem = newElement('li.cards-list__sort-menu__item.relative')
        listOrder.appendChild(menuItem)

        settingsBtn.appendChild(drawIcon('gear', 16))
        settingsBtn.id = 'settingsBtn'
        menuItem.appendChild(settingsBtn)

        menuItem.appendChild(listSettings)


        settingsBtn.addEventListener('click', () => {
            settingsBtn.classList.toggle('active')
            listSettings.classList.toggle('active')
        })
    }

    // поля ввода прогружены
    document.addEventListener('fieldsReady', () => {
        console.log('fieldsReady');

        searchForm.classList.toggle('hidden', !showSearch)

        inputSort.appendAfter(ifField.getByName('search').field)

        let cardsToLoad = ifField.getByName('cardsList_cardsToLoad')
        let listLength = ifField.getByName('cardsList_listLength')
        let hideLegend = ifField.getByName('cardsList_hideLegend')
        let hideIcons = ifField.getByName('cardsList_hideIcons')
        let hideHomebrew = ifField.getByName('cardsList_hideHomebrew')
        let hideSearch = ifField.getByName('cardsList_hideSearch')

        //  прогрузка карточек
        listLength.setNewValue(JSON.stringify([buildElements]))
        listLength.field.addEventListener('change', () => {

            buildElements = parseInt('undefined' !== typeof listLength.value[0] ? listLength.value[0] : buildElements_default)

            setCookie(LIST.category + '_listLength', buildElements)

            resetList()
            buildList()
        })


        // скрытие Homebrew
        hideHomebrew.field.addEventListener('change', () => {

            document.querySelector('.cards-list__group-menu').classList.toggle('hidden', hideHomebrew.value)

            if (hideHomebrew.value) {
                setCookie('hideHomebrew', 1)
            } else {
                Cookies.remove('hideHomebrew')
            }

        })

        // скрыть легенду
        hideLegend.field.addEventListener('change', () => {
            if (hideLegend.value) {
                setCookie(LIST.category + '_hideLegend', 1)
            } else {
                Cookies.remove(LIST.category + '_hideLegend')
            }

            document.querySelector('.cards-list__legend.common').classList.toggle('hidden', hideLegend.value)
            document.querySelector('.cards-list__legend.icons').classList.toggle('hidden', hideLegend.value || hideIcons.value)

        })

        //  скрыть иконки
        hideIcons.field.addEventListener('change', () => {
            document.querySelector('.cards-list__legend.icons').classList.toggle('hidden', hideIcons.value || hideLegend.value)

            showIcons = !hideIcons.value
            resetList()
            buildList()

            if (hideIcons.value) {
                setCookie(LIST.category + '_hideIcons', 1)
            } else {
                Cookies.remove(LIST.category + '_hideIcons')
            }

        })

        //  скрыть поиск
        hideSearch.field.addEventListener('change', () => {
            showSearch = !hideSearch.value
            toggleSearchFormBtn.classList.toggle('btn-hidden', showSearch)
            searchForm.classList.toggle('hidden', !showSearch)

            if (hideSearch.value) {
                setCookie(LIST.category + '_hideSearch', 1)
            } else {
                Cookies.remove(LIST.category + '_hideSearch')
            }

        })

        // размер шрифта
        let fontSize = ifField.getByName('cardsList_fontSize')
        fontSize.field.addEventListener('change', () => {
            let size = typeof fontSize.value[0] !== 'undefined' ? fontSize.value[0] : 15
            cardList.setAttribute('data-font-size', size)
            setCookie('list_fontSize', size)
        })

        // отключаем дропдаун поисковой строки
        let search = ifField.getByName('search')
        search.disableDropdownBlock()

        // window.setTimeout(() => {
        //     console.log('apply GET');
        //     const params = new URLSearchParams(window.location.search);
        //     document.querySelectorAll('.if.filter').forEach((filter) => {
        //         const name = filter.getAttribute('name');
        //         const value = params.get(name);
        //         if (value) {
        //             console.log(name);
        //             console.log(value);
        //             // filter.value = value;
        //             filter.dispatchEvent(new Event('change'))
        //         }
        //     })
        //
        // }, 1);

    })

})()